const getImageLink = (imageName) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:1234";
    return BASE_URL + "/uploads/" + imageName;
};
export default getImageLink;
